import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const LockIcon = createIcon({
  displayName: 'LockIcon',
  path: [
    <path
      d='M5.75 11.75C5.75 11.1977 6.19772 10.75 6.75 10.75H17.25C17.8023 10.75 18.25 11.1977 18.25 11.75V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.75Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M7.74995 10.5V10.3427C7.74995 8.78147 7.65602 7.04125 8.74641 5.9239C9.36824 5.2867 10.3745 4.75 12 4.75C13.6255 4.75 14.6317 5.2867 15.2535 5.9239C16.3439 7.04125 16.25 8.78147 16.25 10.3427V10.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ],
  defaultProps: defaultProps
})
